export const DEFAULT_LIVE_CHAT_SECTION_COLORS = { barColor: 'black', bubbleColor: 'black' };
